import React from 'react';

export const IchiPlusIcon = props => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 152 152' {...props}>
    <g id='レイヤー_2' data-name='レイヤー 2'>
      <g
        id='高所作業車予約システムのコピー_2'
        data-name='高所作業車予約システムのコピー 2'
      >
        <rect width='152' height='152' fill='#fff' />
        <path
          d='M70.23,33.28H52.78l1.5-14.42H71.72ZM54.61,31.63H68.74L69.9,20.5H55.76Z'
          fill='#069'
        />
        <rect x='22.79' y='15.6' width='25' height='1.64' fill='#069' />
        <rect
          x='48.05'
          y='25.86'
          width='28.41'
          height='1.64'
          transform='translate(28.57 85.44) rotate(-83.38)'
          fill='#069'
        />
        <rect
          x='109.76'
          y='26.22'
          width='26.64'
          height='1.64'
          transform='translate(82.03 146.18) rotate(-83.38)'
          fill='#069'
        />
        <rect
          x='100.68'
          y='25.17'
          width='21.17'
          height='1.64'
          transform='translate(72.62 133.51) rotate(-83.38)'
          fill='#069'
        />
        <rect x='50.75' y='15.6' width='25' height='1.64' fill='#069' />
        <rect x='48.56' y='35.07' width='25' height='1.64' fill='#069' />
        <rect
          x='33.47'
          y='13.82'
          width='4.17'
          height='1.64'
          transform='translate(16.91 48.28) rotate(-83.38)'
          fill='#069'
        />
        <rect
          x='89.05'
          y='18.74'
          width='2.64'
          height='1.64'
          transform='translate(60.52 107.08) rotate(-83.38)'
          fill='#069'
        />
        <path
          d='M40.45,25.28h-12l.67-6.45h12ZM30.31,23.63H39l.33-3.16H30.64Z'
          fill='#069'
        />
        <path
          d='M37.06,38.77H28.87l.88-8.47h8.19Zm-6.37-1.64h4.89l.54-5.19H31.23Z'
          fill='#069'
        />
        <polygon
          points='24.14 40.93 22.5 40.76 23.95 26.86 44.29 26.86 42.83 40.93 41.19 40.76 42.47 28.5 25.43 28.5 24.14 40.93'
          fill='#069'
        />
        <rect x='54.28' y='25.25' width='15.79' height='1.64' fill='#069' />
        <rect x='48.43' y='53.35' width='54.73' height='30.82' fill='#91bdd3' />
        <path
          d='M103.9,84.92H47.68V52.61H103.9Zm-54.72-1.5h53.23V54.1H49.18Z'
          fill='#069'
        />
        <rect
          x='48.43'
          y='120.03'
          width='54.73'
          height='15.41'
          fill='#91bdd3'
        />
        <path
          d='M103.9,136.19H47.68v-16.9H103.9ZM49.18,134.7h53.23V120.78H49.18Z'
          fill='#069'
        />
        <polygon
          points='93.42 120.7 75.79 111.9 58.16 120.7 57.5 119.36 75.79 110.23 94.09 119.36 93.42 120.7'
          fill='#069'
        />
        <path
          d='M75.79,111.81a.75.75,0,0,1-.33-.07l-18-9a.74.74,0,0,1-.42-.67.75.75,0,0,1,.42-.67l18-9a.72.72,0,0,1,.67,0l18,9a.76.76,0,0,1,.41.67.75.75,0,0,1-.41.67l-18,9A.8.8,0,0,1,75.79,111.81ZM59.5,102.1l16.29,8.13,16.29-8.13L75.79,94Z'
          fill='#069'
        />
        <polygon
          points='75.79 93.97 57.5 84.84 58.16 83.5 75.79 92.3 93.42 83.5 94.09 84.84 75.79 93.97'
          fill='#069'
        />
        <circle cx='89' cy='135.44' r='8.34' fill='#fff' />
        <path
          d='M89,144.53a9.09,9.09,0,1,1,9.09-9.09A9.1,9.1,0,0,1,89,144.53Zm0-16.68a7.6,7.6,0,1,0,7.6,7.59A7.59,7.59,0,0,0,89,127.85Z'
          fill='#069'
        />
        <circle cx='62.59' cy='135.44' r='8.34' fill='#fff' />
        <path
          d='M62.59,144.53a9.09,9.09,0,1,1,9.08-9.09A9.1,9.1,0,0,1,62.59,144.53Zm0-16.68a7.6,7.6,0,1,0,7.59,7.59A7.6,7.6,0,0,0,62.59,127.85Z'
          fill='#069'
        />
        <path
          d='M97.83,40.37H81.21l1.91-17h15l-.8,7.13H84l-.18,1.66h15ZM83.05,38.73H96.36l.55-4.88H83.6Zm1.11-9.83H95.83l.44-3.85H84.59Z'
          fill='#069'
        />
        <rect x='113.28' y='38.73' width='17.53' height='1.64' fill='#069' />
        <polygon
          points='102.15 25.73 100.52 25.56 100.92 21.7 80.66 21.7 80.24 25.73 78.61 25.56 79.18 20.05 102.74 20.05 102.15 25.73'
          fill='#069'
        />
        <rect x='83.09' y='14.09' width='8.18' height='1.64' fill='#069' />
        <rect
          x='78.38'
          y='14.9'
          width='8.02'
          height='1.64'
          transform='translate(16.69 67.87) rotate(-49.24)'
          fill='#069'
        />
        <rect
          x='86.56'
          y='14.76'
          width='1.64'
          height='4.21'
          transform='translate(0.1 34.21) rotate(-22.16)'
          fill='#069'
        />
        <rect x='95.4' y='14.09' width='8.8' height='1.64' fill='#069' />
        <rect
          x='90.69'
          y='14.9'
          width='8.02'
          height='1.64'
          transform='translate(20.97 77.19) rotate(-49.24)'
          fill='#069'
        />
        <rect
          x='98.87'
          y='14.76'
          width='1.64'
          height='4.21'
          transform='translate(1.01 38.88) rotate(-22.18)'
          fill='#069'
        />
        <rect x='107.78' y='14.65' width='9.25' height='1.64' fill='#069' />
        <rect x='106.98' y='23.9' width='8.49' height='1.64' fill='#069' />
        <rect x='118.71' y='20.84' width='10.66' height='1.64' fill='#069' />
        <rect x='115.48' y='33.16' width='14.3' height='1.64' fill='#069' />
        <rect
          x='104.74'
          y='35.77'
          width='9.7'
          height='1.64'
          transform='translate(-5.03 22.07) rotate(-11.24)'
          fill='#069'
        />
        <path
          d='M129.21,30.54H116.63L118.5,13h12.58Zm-10.75-1.65h9.28l1.52-14.26H120Z'
          fill='#069'
        />
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/icons/IchiPlusIcon.jsx